<template>
  <div id="page-nodes-details">
    <nodes-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Create Nodes"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'content-management.nodes.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            :disabled="loading"
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
  import NodesForm from "@/views/pages/content-management/nodes/Form";
  import NotificationMixin from "@/components/mixins/NotificationMixin";
  import SaveModelMixin from '@/components/mixins/SaveModelMixin';
  import moment from 'moment';
  
  export default {
    name: "NodesCreate",
    components: {
      NodesForm
    },
    mixins: [NotificationMixin, SaveModelMixin],
    data() {
      return {
        model: {},
        loading: false,
      };
    },
    created() {
      this.setDefaultStartDate();
    },
    methods: {
      getParams() {
        const params = {
          ...this.model
        }
  
        const references = [
          'Parent_CommercialProductNode_FK',
          'Localization_FK',
        ]

        references.forEach((ref) => params[ref] = this.getReferenceId(ref))
  
        return params;
      },
      getReferenceId(fieldName) {
        if (!this.model[fieldName]) {
          return null;
        }
  
        return this.model[fieldName].id || null;
      },
      async create() {
        if (!this.$refs.form.validate()) {
          this.notifyError('Not all required fields have been provided');
          return false;
        }
  
        // this.loading = true;
        const params = this.getParams();

        try {
          const {data} = await this.$api.contentManagementNodes.create(params);
          this.notifySuccess('Node created');
          this.$router.back();
        } catch (e) {
          this.notifyError('Node creation failed');
          console.error(e)
        } finally {
        }
      },
      setDefaultStartDate() {
        this.model.NodesValidFrom = moment().format('YYYY-MM-DD 00:00:00');
      },
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  